import { Component, effect, inject, OnInit } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import { BadgeModule } from 'primeng/badge';
import { ButtonDirective } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataLayerDataListComponent } from '../data-layer-data-list/data-layer-data-list.component';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';
import { PrimeTemplate } from 'primeng/api';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { getState } from '@ngrx/signals';

@Component({
  selector: 'app-confirm-publication-data-layer',
  standalone: true,
  imports: [
    AccordionModule,
    AlertComponent,
    BadgeModule,
    ButtonDirective,
    ConfirmDialogModule,
    DataLayerDataListComponent,
    DividerModule,
    HeaderComponent,
    PrimeTemplate,
    ScrollPanelModule,
    AlertStyleDirective,
  ],
  templateUrl: './confirm-publication-data-layer.component.html',
  styleUrl: './confirm-publication-data-layer.component.scss',
})
export class ConfirmPublicationDataLayerComponent implements OnInit {
  readonly indicatorDataStore = inject(IndicatorDataStore);
  readonly layerStore = inject(DataLayerStore);
  dataLayerToChangePublishStatus = this.layerStore.selectedItem();
  layerHasData = false;

  constructor() {
    effect(() => {
      const layerState = getState(this.layerStore);
      if (layerState.selectedId) {
        this.dataLayerToChangePublishStatus = this.layerStore.selectedItem();
        this.checkForData();
      }
    });
  }

  /**
   * Angular lifecycle hook that is called after the component's view has been initialized.
   * Typically used to perform initialization logic, such as data retrieval or setup tasks.
   *
   * @return {void} No return value as this method is primarily intended for initialization purposes.
   */
  ngOnInit(): void {
    this.checkForData();
  }

  /**
   * Checks for the presence of a specific data layer type to delete and filters type layers by its parent ID.
   * Updates the typeLayers property with the filtered results.
   *
   * @return {void} This method does not return a value.
   */
  checkForData(): void {
    if (!this.dataLayerToChangePublishStatus) return;
    this.layerHasData = this.indicatorDataStore.dataLayerHasData(
      this.dataLayerToChangePublishStatus._id
    );
  }
}
